import { network } from './network';

export async function getProductList(opts) {
	const res = await network({
		url: '/api/v1/shop/products',
		method: 'post',
		params: {},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getProductInfo(opts) {
	const res = await network({
		url: '/api/v1/shop/product_info',
		method: 'post',
		params: {
			product_id: opts.productId
		},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function creditsRedeem(opts) {
	const res = await network({
		url: '/api/v1/shop/credits_redeem',
		method: 'post',
		params: {
			sku_id: opts.sku_id
		},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}
